<template>
  <div>
    <div class="flex h-[84px] items-center gap-3 bg-[#f3f3f3] px-3">
      <button class="text-[#716f6f]" @click.prevent="$emit('close')">
        <SpriteSymbol name="close-2" class="size-3" />
      </button>
      <div class="size-[64px] overflow-hidden rounded-[15px]">
        <img
          width="480"
          height="480"
          src="~/assets/images/zt-app-icon.webp"
          alt="Zürich Tourismus"
        />
      </div>
      <div class="leading-snug text-black">
        <div class="font-bold">Zürich City Guide</div>
        <div class="text-size-7">Zürich Tourism</div>
        <div class="text-size-7">
          {{ $texts('smartbanner.bottom') }}
        </div>
      </div>
      <a
        href="https://play.google.com/store/apps/details?id=com.zuerich.tourismus"
        target="_blank"
        class="ml-auto p-3 text-[18px] text-[#1474fc]"
      >
        {{ $texts('smartbanner.button') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['close'])

const { $texts } = useEasyTexts()
</script>
